import { LegalLayout, LegalSection } from "./LegalLayout";
import { AUTHOR_EMAIL, AUTHOR_NAME, PRODUCT_NAME, PRICE_NEW } from "../lib/site";

export const TermsPage = () => (
  <LegalLayout title="Regulamin sklepu" testid="terms-page" updated="wrzesień 2026">
    <LegalSection title="§1. Postanowienia ogólne">
      <p>
        Niniejszy regulamin określa zasady sprzedaży produktów cyfrowych za
        pośrednictwem strony internetowej, prowadzonej przez {AUTHOR_NAME}{" "}
        (kontakt: {AUTHOR_EMAIL}, prawodorzeczy.pl), zwaną dalej Sprzedawcą.
      </p>
      <p>
        Akceptacja regulaminu jest dobrowolna, ale niezbędna do dokonania
        zakupu — potwierdzasz ją przed przejściem do płatności.
      </p>
    </LegalSection>

    <LegalSection title="§2. Przedmiot sprzedaży">
      <p>
        Przedmiotem sprzedaży są produkty cyfrowe, w szczególności {PRODUCT_NAME}{" "}
        — zestaw wzorów dokumentów prawnych (m.in. checklista Sanepid + PIP,
        regulamin rezerwacji z klauzulą no-show, wzór umowy dla gastronomii,
        klauzula RODO do monitoringu) w formatach DOC i PDF.
      </p>
      <p>
        Dokumenty są wzorami do samodzielnego uzupełnienia i nie stanowią
        indywidualnej porady prawnej.
      </p>
    </LegalSection>

    <LegalSection title="§3. Zamówienia i płatność">
      <p>
        Cena produktu wynosi {PRICE_NEW} brutto. Płatność realizowana jest z
        góry za pośrednictwem operatora płatności Stripe. Sprzedawca nie
        przechowuje danych kart płatniczych.
      </p>
      <p>Umowa sprzedaży zostaje zawarta z chwilą zaksięgowania płatności.</p>
    </LegalSection>

    <LegalSection title="§4. Dostawa produktu">
      <p>
        Link do pobrania produktu udostępniany jest niezwłocznie po
        zaksięgowaniu płatności — na ekranie potwierdzenia oraz w wiadomości
        e-mail wysłanej na adres podany przy płatności.
      </p>
    </LegalSection>

    <LegalSection title="§5. Prawa autorskie i licencja">
      <p>
        Wszystkie dokumenty objęte są prawami autorskimi Sprzedawcy. Zakupem
        nabywasz niewyłączną licencję na użytek własny w ramach jednej
        prowadzonej przez siebie działalności gospodarczej.
      </p>
      <p>
        Zabronione jest odsprzedawanie, udostępnianie osobom trzecim i
        publikowanie dokumentów w całości lub w części.
      </p>
    </LegalSection>

    <LegalSection title="§6. Prawo odstąpienia od umowy">
      <p>
        Zgodnie z art. 38 pkt 13 ustawy o prawach konsumenta prawo odstąpienia
        od umowy nie przysługuje w odniesieniu do treści cyfrowych
        niedostarczanych na nośniku materialnym, jeżeli spełnianie świadczenia
        rozpoczęło się za wyraźną zgodą konsumenta przed upływem terminu do
        odstąpienia i po poinformowaniu go o utracie tego prawa.
      </p>
      <p>
        Przechodząc do płatności i pobierając produkt, wyrażasz zgodę na
        natychmiastowe rozpoczęcie dostarczania treści cyfrowych.
      </p>
    </LegalSection>

    <LegalSection title="§7. Reklamacje">
      <p>
        Reklamacje można zgłaszać na adres {AUTHOR_EMAIL}. Reklamacja zostanie
        rozpatrzona w terminie 14 dni od jej otrzymania.
      </p>
    </LegalSection>

    <LegalSection title="§8. Dane osobowe">
      <p>
        Zasady przetwarzania danych osobowych opisuje{" "}
        <a href="/polityka-prywatnosci" className="font-medium text-brick underline underline-offset-2">
          Polityka prywatności
        </a>
        . Płatności przetwarza Stripe Payments Europe, Ltd.
      </p>
    </LegalSection>

    <LegalSection title="§9. Postanowienia końcowe">
      <p>
        Do umowy stosuje się prawo polskie. Sprzedawca zastrzega sobie prawo do
        zmiany regulaminu; zmiany wchodzą w życie z chwilą publikacji na stronie
        i nie dotyczą zamówień złożonych przed zmianą.
      </p>
    </LegalSection>
  </LegalLayout>
);
